module.exports = __webpack_public_path__ + "static/img/load.98d913de.png";